import { render, staticRenderFns } from "./NodePoolsPage.vue?vue&type=template&id=22a25006&scoped=true&"
import script from "./NodePoolsPage.vue?vue&type=script&lang=js&"
export * from "./NodePoolsPage.vue?vue&type=script&lang=js&"
import style0 from "./NodePoolsPage.vue?vue&type=style&index=0&id=22a25006&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a25006",
  null
  
)

export default component.exports